import { render, staticRenderFns } from "./external-settings.vue?vue&type=template&id=07cfc545&"
import script from "./external-settings.vue?vue&type=script&lang=js&"
export * from "./external-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeader: require('/home/vsts/work/1/s/components/PageHeader.vue').default})
